import {
  View,
  Text,
  StyleSheet,
  TextInput,
  TouchableOpacity,
} from "react-native";
import React, { useEffect, useState, useRef } from "react";

import { v4 as uuidv4 } from "uuid";

import BlockDescriptionView from "../../Block/BlockDescriptionView";
import Serie from "../../Firestore/Serie";

import SerieRowView from "../../Serie/SerieRowView";
import WorkoutDescriptionView from "../../Workout/WorkoutDescriptionView";
import GlobalStyles from "../../../Resources/Styles";
import Colors from "../../../Resources/Color";
import Fonts from "../../../Resources/Fonts";
import CustomAlert from "../../Components/CustomAlert";
import Tooltip from "../../Components/Tooltip";
import { observer, Observer } from "mobx-react";
import { reaction } from "mobx";
import { useTranslation } from "react-i18next";
import BlockOverview from "../../Block/BlockOverview";
import { useScreenDimensions, useDevice } from "../../_layout";
import IconEmptyView from "../../Components/IconEmptyView";
import { ScrollView } from "react-native-web";

import BlockListView from "../../Block/BlockListView";
import BackButton from "../../Components/BackButton";
import EditWorkoutView from "../../Workout/EditWorkoutView";
import InfoView from "../../Block/InfoView";
import { formatNumber } from "../../utils/numberUtils";

import ImageMessageManager from "../../Classes/ImageMessageManager";
import { Menu, MenuItem } from "react-native-material-menu";
import { AntDesign, Ionicons } from "@expo/vector-icons";
import { MaterialCommunityIcons } from "@expo/vector-icons";
import { Octicons } from "@expo/vector-icons";
import { Feather } from "@expo/vector-icons";
import { Entypo } from "@expo/vector-icons";
import { format } from "date-fns";
import AddToCalendarView from "../../Block/AddToCalendarView";
import WorkoutRowView from "../../Workout/WorkoutRowView";
import AddRow from "../../Components/AddRow";
import { ProtocolTitles, UISections } from "../../../Resources/Constants";

import SearchBar from "../../Components/SearchBar";
import PredefinedAttributeLayoutView from "../../Exercise/PredefinedAttributeLayoutView";
import PredefinedExerciseLayoutView from "../../Exercise/PredefinedExerciseLayoutView";
import Workout from "../../Firestore/Workout";
import Exercise from "../../Firestore/Exercise";
import Attribute from "../../Firestore/Attribute";

import { useDrag, useDrop } from "react-dnd";
import DeleteBlockView from "../../Block/DeleteBlockView";
import CopyBlockToClient from "../../Block/CopyBlockToClient";

import BlockDashboard from "../../Block/BlockDashboard";
import TutorialLinkSection from "../../Components/TutorialLinkSection";
import { useToast } from "../../contexts/ToastContext";

const ClientPlanification = observer(({ client }) => {
  const { t, i18n } = useTranslation();
  const { screenSize } = useScreenDimensions();
  const { isMobile } = useDevice();

  const [showingAddToCalendar, setShowingAddToCalendar] = useState(false);

  const [showingCopyToClient, setShowingCopyToClient] = useState(false);

  const [showingDeleteAlert, setShowingDeleteAlert] = useState(false);
  const deleteAlertTitle = "deleteBlockAlertTitle-string";
  const deleteAlertText = "deleteBlockAlertText-string";

  const deleteBlock = () => {
    if (client.selectedBlock) {
      client.deleteBlock(client.selectedBlock);
    }
    setShowingDeleteAlert(false);
  };

  const TabPickerHeader = ({ block }) => {
    const TabPickerButton = observer(({ isDashboard }) => {
      const [isHovered, setIsHovered] = useState(false);

      return isDashboard ? (
        <TouchableOpacity
          onPress={() => block.setProperty("isShowingDashboard", true)}
          style={{ flexShrink: 1 }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              alignItems: "center",
              flexShrink: 1,
            }}
          >
            <Text
              style={{
                fontSize: 14,
                fontWeight: "500",
                color:
                  block.isShowingDashboard || isHovered
                    ? Colors.bubbleColor
                    : Colors.blackColor,
                width: "100%",
              }}
              numberOfLines={1}
            >
              {t("dashboard-string")}
            </Text>
            <View
              style={[
                styles.underline,
                {
                  backgroundColor: !block.isShowingDashboard
                    ? "transparent"
                    : Colors.bubbleColor,
                },
              ]}
            />
          </View>
        </TouchableOpacity>
      ) : (
        <TouchableOpacity
          onPress={() => block.setProperty("isShowingDashboard", false)}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          <View
            style={{
              alignItems: "center",
              marginRight: screenSize === "medium" ? 8 : 16,
            }}
          >
            <Text
              style={{
                fontSize: 14,
                fontWeight: "500",
                color:
                  !block.isShowingDashboard || isHovered
                    ? Colors.bubbleColor
                    : Colors.blackColor,
              }}
            >
              {t("workouts-string")}
            </Text>
            <View
              style={[
                styles.underline,
                {
                  backgroundColor: !block.isShowingDashboard
                    ? Colors.bubbleColor
                    : "transparent",
                },
              ]}
            />
          </View>
        </TouchableOpacity>
      );
    });
    return (
      <View
        style={[
          GlobalStyles.HStack,
          {
            justifyContent: "space-evenly",
            flexDirection: "row",
          },
        ]}
      >
        <TabPickerButton isDashboard={false} />

        <TabPickerButton isDashboard={true} />
      </View>
    );
  };

  const AddToCalendarButton = observer(({ block }) => {
    const [isHovered, setIsHovered] = useState(false);
    const hasAtLeastOneWorkoutWithExercises = block.workouts.some(
      (w) => w.exercises && w.exercises.length > 0
    );

    const allWorkoutsHaveExercises = block.workouts.every(
      (w) => w.exercises && w.exercises.length > 0
    );

    const allWorkoutsWithDate = block.workouts.every((w) => w.date);

    const buttonContent = (
      <TouchableOpacity
        onPress={
          hasAtLeastOneWorkoutWithExercises
            ? setShowingAddToCalendar
            : undefined
        }
        disabled={!hasAtLeastOneWorkoutWithExercises}
        style={{
          flexShrink: 1,
          opacity:
            isHovered || !allWorkoutsHaveExercises || allWorkoutsWithDate
              ? 0.6
              : 1,
        }}
        onMouseEnter={() => !isMobile && setIsHovered(true)}
        onMouseLeave={() => setIsHovered(false)}
      >
        <View
          style={{
            height: 28,
            backgroundColor: !hasAtLeastOneWorkoutWithExercises
              ? Colors.grayColor
              : Colors.bubbleColor,
            borderRadius: 12,
            borderWidth: 1,
            borderColor: !hasAtLeastOneWorkoutWithExercises
              ? Colors.grayColor
              : Colors.bubbleColor,
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Text
            style={{
              textAlign: "center",
              textAlignVertical: "center",
              color: Colors.whiteColor,
              paddingHorizontal: 8,
              fontSize: 11,
            }}
          >
            {t("addToCalendar-string")}
          </Text>
        </View>
      </TouchableOpacity>
    );

    return !hasAtLeastOneWorkoutWithExercises ? (
      <Tooltip
        content="createWorkoutsBeforeAddingToCalendar-string"
        placement="top"
        maxWidth={250}
      >
        {buttonContent}
      </Tooltip>
    ) : (
      buttonContent
    );
  });

  const BlockTitle = observer(({ block }) => {
    const [isHovered, setIsHovered] = useState(false);
    const { showToast } = useToast();

    const [blockMenu, setBlockMenu] = useState(false);
    const showBlockMenu = () => setBlockMenu(true);

    const MenuItemView = ({ index }) => {
      const [isHovered, setIsHovered] = useState(false);

      const showCopyToClient = () => {
        setShowingCopyToClient(true);
        setBlockMenu(false);
      };

      const addToLibrary = () => {
        block.copyBlockToLibrary(showToast);
        setBlockMenu(false);
        setIsHovered(false);
      };

      const showDeleteAlert = () => {
        setShowingDeleteAlert(true);
        setBlockMenu(false);
      };

      return index === 0 ? (
        <MenuItem
          onPress={() => {
            const newBlock = client.copyBlock(
              t,
              block,
              false,
              undefined,
              showToast
            );
            client.updateClientTransactionData(newBlock.id);
            client.startOrResetBatchTimer();
            setBlockMenu(false);
          }}
          style={{ minWidth: 190 }}
          textStyle={{
            fontSize: 14,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("copyBlock-string")}
        </MenuItem>
      ) : index === 1 ? (
        <MenuItem
          onPress={() => {
            const newBlock = client.copyBlock(
              t,
              block,
              true,
              undefined,
              showToast
            );
            client.updateClientTransactionData(newBlock.id);
            client.startOrResetBatchTimer();
            setBlockMenu(false);
          }}
          style={{ minWidth: 190 }}
          textStyle={{
            fontSize: 14,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("copyFullBlock-string")}
        </MenuItem>
      ) : index === 2 ? (
        <MenuItem
          onPress={showCopyToClient}
          style={{ minWidth: 190 }}
          textStyle={{
            fontSize: 14,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("copyToAnotherClient-string")}
        </MenuItem>
      ) : index === 3 ? (
        <MenuItem
          onPress={addToLibrary}
          style={{ minWidth: 190 }}
          textStyle={{
            fontSize: 14,
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("exportToLibrary-string")}
        </MenuItem>
      ) : (
        <MenuItem
          onPress={showDeleteAlert}
          style={{ minWidth: 190 }}
          textStyle={{
            fontSize: 14,
            color: "red",
            fontWeight: isHovered ? "600" : "normal",
          }}
          onMouseEnter={() => !isMobile && setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
        >
          {t("delete-string")}
        </MenuItem>
      );
    };
    return (
      <View
        style={{
          width: screenSize === "small" && "100%",
          ...(screenSize === "small" ? { flex: 1 } : {}),
          flexShrink: 1,
        }}
      >
        <View
          style={{
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "space-between",
          }}
        >
          <Text
            style={[Fonts.bold18, { marginRight: 12 }]}
            numberOfLines={2}
            onPress={() => {
              if (screenSize === "small") {
                if (block.client) {
                  block.client.setSelectedBlock(null);
                } else if (block.coach) {
                  block.coach.setSelectedBlock(null);
                }
              }
            }}
          >
            {block.name}
          </Text>
          <Menu
            visible={blockMenu}
            anchor={
              <TouchableOpacity
                onPress={showBlockMenu}
                style={{ opacity: isHovered ? 0.5 : 1 }}
                onMouseEnter={() => !isMobile && setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <Entypo name="dots-three-horizontal" size={22} color="black" />
              </TouchableOpacity>
            }
            style={[GlobalStyles.menu]}
            onRequestClose={() => setBlockMenu(false)}
          >
            <MenuItemView index={0} />
            <MenuItemView index={1} />
            <MenuItemView index={2} />
            <MenuItemView index={3} />
            <MenuItemView index={4} />
          </Menu>
        </View>

        <View
          style={{
            backgroundColor: Colors.blackColor,
            height: 1,
            opacity: 0.2,
            marginTop: 8,
          }}
        />
      </View>
    );
  });

  const PlanView = observer(({ block }) => {
    return (
      <View
        style={{
          flex: 1,
        }}
      >
        {block && block.selectedWorkout && (
          <>
            {block.selectedWorkout.showingEditWorkout ? (
              <View
                style={{
                  paddingBottom: 0,
                  borderRadius: 14,
                  borderWidth: 0.1,
                  borderColor: Colors.borderColor,
                }}
              >
                <EditWorkoutView
                  coach={client.coach}
                  workout={block.selectedWorkout}
                />
              </View>
            ) : (
              <View
                style={{
                  paddingBottom: 0,
                  borderRadius: 14,
                  borderWidth: 0.1,
                  borderColor: Colors.borderColor,
                }}
              >
                <WorkoutDescriptionView workout={block.selectedWorkout} />
              </View>
            )}
          </>
        )}
      </View>
    );
  });

  return (
    <View
      style={{
        flex: 1, //En principi no ha passat res per deixarlo. Assegurar
        justifyContent: "space-between",
        marginTop: screenSize === "small" ? 16 : 24,
      }}
    >
      {!client.selectedBlock ? (
        <>
          <View
            style={{
              flexDirection: screenSize != "large" ? "column" : "row",
              flex: 1,
            }}
          >
            {/* <TouchableOpacity
            onPress={() => {
              client.createDemoClientData();
            }}
          >
            <Text>CREATE DEMO BLOCK</Text>
          </TouchableOpacity> */}

            {(screenSize === "large" || !client.shownBlock) && (
              <View
                style={{
                  width: screenSize === "large" ? "25%" : "100%",
                }}
              >
                <BlockListView client={client} />
              </View>
            )}

            {client.shownBlock ? (
              <View style={{ gap: 8, flex: 1 }}>
                {screenSize != "large" && (
                  <BackButton
                    action={() =>
                      client && client.shownBlock.setProperty("isShown", false)
                    }
                    backString={t("back-string")}
                  />
                )}

                <BlockOverview block={client.shownBlock} />
              </View>
            ) : (
              <>
                {!client.selectedBlock && (
                  <>
                    {client.blocks.length > 0 ? (
                      <IconEmptyView
                        iconLibrary={"Ionicons"}
                        mainText={"blockSummary-string"}
                        subText={"openBlockSummary-string"}
                        iconName={"clipboard-outline"}
                        marginTop={client.blocks.length > 4 ? 36 : 24}
                      />
                    ) : (
                      <IconEmptyView
                        iconLibrary={"Ionicons"}
                        mainText={"withoutBlocks-string"}
                        subText={"withoutBlocksText-string"}
                        iconName={"clipboard-outline"}
                        marginTop={130}
                      />
                    )}
                  </>
                )}
              </>
            )}
          </View>
        </>
      ) : (
        <View
          style={{
            width: "100%",
          }}
        >
          {screenSize != "small" && (
            <View style={{ marginBottom: 12 }}>
              <BackButton
                action={() => {
                  client.setSelectedBlock(null);
                }}
                backString={t("back-string")}
              />
            </View>
          )}

          <View
            style={{
              width: "100%",
              flexDirection: screenSize !== "small" && "row",
              marginBottom: 16,
              alignItems: "center",
              gap: screenSize != "small" ? 16 : 0,
            }}
          >
            <BlockTitle block={client.selectedBlock} />
            {screenSize != "small" && <View style={{ flex: 1 }} />}
            <View
              style={{
                width: screenSize === "small" && "100%",
                flexDirection: "row",
                marginTop: screenSize === "small" && 16,
                alignItems: "center",
                gap: 16,
                justifyContent:
                  screenSize === "small" ? "space-between" : "flex-end",
              }}
            >
              <AddToCalendarButton block={client.selectedBlock} />
              <TabPickerHeader block={client.selectedBlock} />
            </View>
          </View>

          {client.selectedBlock.isShowingDashboard ? (
            <>
              {client?.coach?.shouldShowUISectionInfo(
                UISections.PROGRAM_DASHBOARD_V1
              ) &&
                !client.coach.hideBlockDashboard && (
                  <TutorialLinkSection
                    text="tutorialProgramDashboard-string"
                    urlPath="/program/create-full-block"
                    marginTop={8}
                    marginBottom={16}
                    showCloseButton={true}
                    onClose={async () =>
                      await client.coach.markUISectionAsShown(
                        UISections.PROGRAM_DASHBOARD_V1
                      )
                    }
                  />
                )}
              <BlockDashboard block={client.selectedBlock} />
            </>
          ) : (
            <>
              {client?.coach?.shouldShowUISectionInfo(
                UISections.PROGRAM_WORKOUTS_V1
              ) && (
                <TutorialLinkSection
                  text="tutorialProgramWorkouts-string"
                  urlPath="/program/create-workout"
                  marginTop={8}
                  marginBottom={16}
                  showCloseButton={true}
                  onClose={async () =>
                    await client.coach.markUISectionAsShown(
                      UISections.PROGRAM_WORKOUTS_V1
                    )
                  }
                />
              )}

              <View
                style={{
                  flexDirection: screenSize === "large" ? "row" : "column",
                  gap: screenSize === "small" ? 8 : 24,
                  width: "100%",
                }}
              >
                <View
                  style={{
                    width: screenSize === "large" ? "20%" : "100%",
                  }}
                >
                  <BlockDescriptionView block={client.selectedBlock} />
                </View>
                {screenSize === "small" ? (
                  <>
                    {client.selectedBlock.selectedWorkout &&
                    (client.selectedBlock.selectedWorkout.selectedExercise ||
                      client.selectedBlock.selectedWorkout
                        ?.selectedExerciseToAdd) &&
                    client.showingInfoView ? (
                      <View style={{ flex: 1 }}>
                        {/* <View style={{ marginBottom: 8 }}>
                        <BackButton
                          action={() =>
                            client.setProperty("showingInfoView", false)
                          }
                          backString={t("back-string")}
                        />
                      </View> */}
                        <View
                          style={{
                            width: "100%",
                          }}
                        >
                          <InfoView
                            client={client}
                            exercise={
                              client.selectedBlock.selectedWorkout
                                ?.showingEditWorkout
                                ? client.selectedBlock.selectedWorkout
                                    ?.selectedExerciseToAdd
                                : client.selectedBlock.selectedWorkout
                                    ?.selectedExercise
                            }
                          />
                        </View>
                      </View>
                    ) : (
                      <PlanView block={client.selectedBlock} />
                    )}
                  </>
                ) : (
                  <>
                    <View
                      style={{
                        flexDirection: "row",
                        flex: 1,
                        gap: 24,
                      }}
                    >
                      <PlanView block={client.selectedBlock} />
                      <View
                        style={{
                          width: screenSize === "medium" ? "35%" : "32%",
                        }}
                      >
                        <InfoView
                          client={client}
                          exercise={
                            client.selectedBlock.selectedWorkout
                              ?.showingEditWorkout
                              ? client.selectedBlock.selectedWorkout
                                  ?.selectedExerciseToAdd
                              : client.selectedBlock.selectedWorkout
                                  ?.selectedExercise
                          }
                        />
                      </View>
                    </View>
                  </>
                )}
              </View>
            </>
          )}

          {showingAddToCalendar && client.selectedBlock && (
            <AddToCalendarView
              client={client}
              isVisible={showingAddToCalendar}
              onClose={() => setShowingAddToCalendar(false)}
              block={client.selectedBlock}
            />
          )}

          {showingDeleteAlert && client.selectedBlock && (
            <DeleteBlockView
              isVisible={showingDeleteAlert}
              onClose={() => setShowingDeleteAlert(false)}
              title={deleteAlertTitle}
              text={deleteAlertText}
              action={deleteBlock}
              nameOfBlock={
                client.selectedBlock ? client.selectedBlock.name : ""
              }
            />
          )}

          {showingCopyToClient && client.selectedBlock && (
            <CopyBlockToClient
              isVisible={showingCopyToClient}
              onClose={() => setShowingCopyToClient(false)}
              block={client.selectedBlock}
            />
          )}
        </View>
      )}
    </View>
  );
});

const styles = StyleSheet.create({
  // container: {
  //   flex: 1,
  //   backgroundColor: "#EFF4F5",
  //   paddingTop: 30,
  //   marginBottom: 20,
  // },
  tabText: {
    //InfoViewRework
    fontSize: 13,
    fontWeight: "500",
  },
  // title: {
  //   fontSize: 14,
  //   fontWeight: "500",
  // },
  // statisticLabel: {
  //   fontSize: 13,
  // },
  // statisticValue: {
  //   flex: 1,
  //   fontSize: 13,
  //   fontWeight: "500",
  //   marginLeft: 5,
  // },
  underline: {
    height: 2,
    width: "100%",
    alignSelf: "center",
    marginTop: 2,
  },
  // textInputStyle: { //Sutilitzava al Dashboard, ja no cal
  //   width: "40%",
  //   height: 40,
  //   borderColor: Colors.borderColor,
  //   backgroundColor: Colors.whiteColor,
  //   color: Colors.blackColor,
  //   borderWidth: 0.1,
  //   padding: 10,
  //   borderRadius: 10,
  //   outlineStyle: "none",
  // },
  // AttributeButton: { //Sutilitzava al Dashboard, ja no cal
  //   borderRadius: 8,
  //   borderWidth: 0.5,
  //   borderColor: Colors.borderColor,
  // },
});

export default ClientPlanification;
